/** PURE_IMPORTS_START .._.._Observable,.._.._operator_retryWhen PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { retryWhen } from '../../operator/retryWhen';
Observable.prototype.retryWhen = retryWhen;
//# sourceMappingURL=retryWhen.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/retryWhen.js
// module id = 706
// module chunks = 0